const configPayment = {
    payment: {
        listLayout: 'PaymentListDefaultLayout',
        filterLayout: 'PaymentFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getOrder',
        listApiParamSet: {
            ip: 1,
            sp:10,
            opr:1
        },
    },
    memberPayment: {
        listLayout: 'PaymentListDefaultLayout',
        filterLayout: 'PaymentFilterPageLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getOrder',
        listApiParamSet: {
            ip: 1,
            sp:10,
            opr:1
        },
    },
    koinUserHistory:{
        listLayout: 'PaymentListKoinUserHistoryLayout',
        filterLayout: 'PaymentFilterUserHistoryLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getPoint',
        listApiParamSet: {
            ip:1,
            sp:10
        },
    },
    koinHistory:{
        listLayout: 'PaymentListKoinHistoryLayout',
        filterLayout: 'PaymentFilterHistoryLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getPoint',
        listApiParamSet: {
            ip:1,
            sp:10
        },
    },
    koin:{
        listLayout: 'PaymentListKoinLayout',
        filterLayout: 'PaymentFilterNoneLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getTicket',
        listApiParamSet: {
            ip:1,
            sp:10
        },
    },
    koinPayment:{
        layout:'KoinDefaultLayout',
        validateKey:['koin','reason']
    },
    koinDelete:{
        layout:'KoinDeleteLayout',
        validateKey:['reason']
    }
}

export default {
    methods: {
        returnPaymentConfig(type) {
            return configPayment[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        //상품명
        ona: {
            type: 'query',
            classname: 'searchInput',
        },
        //사용자닉네임
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        //사용자아이디
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        //주문번호
        oid: {
            type: 'query',
            classname: 'searchInput',
        },
        tab: {
            type: 'match',
            classname: 'tab',
        },
        re: {
            type: 'query',
            classname: 'searchInput',
        },
    }
}
